// extracted by mini-css-extract-plugin
export default {"loader":"SinglePhotoProcessing_loader__7C+0J","rotate":"SinglePhotoProcessing_rotate__BHLNF","prix":"SinglePhotoProcessing_prix__oJAeJ"};